import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../views/HomeView.vue'),
	children: [
		{
			path: '',
			name: 'get',
			component: () => import('../views/GetMemo.vue')
		},
		{
		  path: 'post',
		  name: 'post',
		  component: () => import('../views/PostMemo.vue')
		}
	]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
